import RegistrationService from '@app/model/registration/service/RegistrationService';
import Process from '@app/model/process-request/Process';
import {
	useLatestProcessRequestExecutionStateMonitor
} from '@app/site/secured/rateshopper/rates/provider/useLatestProcessRequestExecutionStateMonitor';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import ProcessRequestExecutionState from '@app/model/process-request/ProcessRequestExecutionState';


const useExecuteRegistrationMarketStateUpdateHook = () => {

	const monitor = useLatestProcessRequestExecutionStateMonitor();
	const [hasFailed, setHasFailed] = useState(false);

	const START_FUNCTION = useMutation({
		mutationFn: RegistrationService.runMarketStateUpdateForCompany,
		onSuccess: (state) => {
			monitor.setLatestActiveExecutionState(new ProcessRequestExecutionState(state));
		},
		onError: () => {
			setHasFailed(true);
		}
	});

	const END_FUNCTION = useMutation({
		mutationFn: RegistrationService.finishMarketStateUpdateForCompany,
		onError: () => {
			setHasFailed(true);
		}
	});

	return {
		start: START_FUNCTION.mutateAsync,
		finish: END_FUNCTION.mutateAsync,
		isFinished: (monitor.latestActiveExecutionState?.process === Process.COMPANY_HOTEL_MARKET_STATE || monitor.latestActiveExecutionState?.process === Process.COMPANY_HOTEL_MARKET_STATE_OTA) && monitor.latestActiveExecutionState.isSuccessful,
		hasFailed: hasFailed || ((monitor.latestActiveExecutionState?.process === Process.COMPANY_HOTEL_MARKET_STATE || monitor.latestActiveExecutionState?.process === Process.COMPANY_HOTEL_MARKET_STATE_OTA) && monitor.latestActiveExecutionState.hasFailed),
	};

};

export default useExecuteRegistrationMarketStateUpdateHook;
